<template>
  <div class="row align-items-center full-height">
    <div class="col">
      <div class="signout-container">
        Thank you for using iPro&reg; Systems Management Applications. You have Successfully Signed Out.
      </div>
    </div>
    <div class="col full-height angled-neg-11deg">
      <small class="copyright left">iPro<span class="registeredTrademark">&reg;</span> Systems &copy; {{ new Date().getFullYear() }}</small>
    </div>
  </div>
</template>

<script>
import { store } from '@/store/index'
import EventBus from '../eventbus'

export default {
  name: 'signout',
  data () {
    return {
    }
  },
  async created () {
    await store.dispatch('auth/signOut')
  },
  mounted () {
    let self = this
    EventBus.$on('signOut', function () {
      console.log(process.env.ACCOUNT_LOC)
      setTimeout(function () {
        self.$router.push(process.env.ACCOUNT_LOC)
      }, 4000)
    })
  }
}
</script>

<style lang="less" scoped>
@import '../less/elements/color.less';
@import '../less/utils/mixins.less';
@import '../less/components/auth.less';

</style>



// WEBPACK FOOTER //
// src/components/signout.vue